// test2894
(2894 && 0);
